import { L10n, createElement } from '@syncfusion/ej2-base';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { TextBox } from '@syncfusion/ej2-inputs';
import { SanitizeHtmlHelper } from '@syncfusion/ej2-base';
/**
 * @private
 */
export class EnforceProtectionDialog {
    constructor(documentHelper, owner) {
        /**
         * @private
         * @returns {void}
         */
        this.show = () => {
            this.localeValue = new L10n('documenteditor', this.viewer.owner.defaultLocale);
            this.localeValue.setLocale(this.viewer.owner.locale);
            if (!this.target) {
                this.initDialog(this.localeValue);
            }
            this.documentHelper.dialog.header = this.localeValue.getConstant('Start Enforcing Protection');
            this.documentHelper.dialog.height = 'auto';
            this.documentHelper.dialog.content = this.target;
            this.documentHelper.dialog.width = 'auto';
            this.documentHelper.dialog.buttons = [{
                    click: this.okButtonClick,
                    buttonModel: { content: this.localeValue.getConstant('Ok'), cssClass: 'e-flat', isPrimary: true }
                },
                {
                    click: this.hideDialog,
                    buttonModel: { content: this.localeValue.getConstant('Cancel'), cssClass: 'e-flat' }
                }];
            this.passwordTextBox.value = '';
            this.confirmPasswordTextBox.value = '';
            this.documentHelper.dialog.show();
        };
        /**
         * @returns {void}
         */
        this.hideDialog = () => {
            this.passwordTextBox.value = '';
            this.confirmPasswordTextBox.value = '';
            this.documentHelper.dialog.hide();
        };
        /**
         * @private
         * @returns {void}
         */
        this.okButtonClick = () => {
            if (this.passwordTextBox.value !== this.confirmPasswordTextBox.value) {
                DialogUtility.alert(this.localeValue.getConstant('Password Mismatch'));
            }
            else {
                this.password = SanitizeHtmlHelper.sanitize(this.passwordTextBox.value);
                this.viewer.owner.editorModule.addProtection(this.password, this.owner.protectionType);
            }
        };
        this.documentHelper = documentHelper;
        this.owner = owner;
    }
    get viewer() {
        return this.owner.viewer;
    }
    initDialog(localValue) {
        //const instance: EnforceProtectionDialog = this;
        //const id: string = this.viewer.owner.containerId + '_enforce_protection';
        this.target = createElement('div', { className: 'e-de-enforce' });
        const passwordContainer = createElement('div', { className: 'e-de-container-row' });
        //const newPassWord: HTMLElement = createElement('div', { className: 'e-de-enforce-dlg-title', innerHTML: localValue.getConstant('Enter new password') });
        this.passwordTextBox = createElement('input', { attrs: { type: 'password', autofocus: 'true' }, className: 'e-input' });
        // this.passwordTextBox.addEventListener('keyup', instance.onKeyUpOnDisplayBox);
        //container.appendChild(newPassWord);
        passwordContainer.appendChild(this.passwordTextBox);
        const confirmPasswordcontainer = createElement('div');
        //const confirmPassword: HTMLElement = createElement('div', { className: 'e-de-enforce-dlg-title', innerHTML: localValue.getConstant('Reenter new password to confirm') }) as HTMLDivElement;
        this.confirmPasswordTextBox = createElement('input', { attrs: { type: 'password' }, className: 'e-input' });
        //container.appendChild(confirmPassword);
        confirmPasswordcontainer.appendChild(this.confirmPasswordTextBox);
        this.target.appendChild(passwordContainer);
        this.target.appendChild(confirmPasswordcontainer);
        new TextBox({ placeholder: localValue.getConstant('Enter new password'), floatLabelType: 'Always', cssClass: 'e-de-enforce-dlg-input' }, this.passwordTextBox);
        new TextBox({ placeholder: localValue.getConstant('Reenter new password to confirm'), floatLabelType: 'Always' }, this.confirmPasswordTextBox);
    }
    /**
     * @private
     * @returns {void}
     */
    destroy() {
        this.documentHelper = undefined;
        this.owner = undefined;
    }
}
/**
 * @private
 */
export class UnProtectDocumentDialog {
    constructor(documentHelper, owner) {
        /**
         * @private
         * @returns {void}
         */
        this.show = () => {
            this.localObj = new L10n('documenteditor', this.viewer.owner.defaultLocale);
            this.localObj.setLocale(this.viewer.owner.locale);
            if (!this.target) {
                this.initDialog(this.localObj);
            }
            this.documentHelper.dialog.header = 'Unprotect Document';
            this.documentHelper.dialog.height = 'auto';
            this.documentHelper.dialog.width = 'auto';
            this.documentHelper.dialog.content = this.target;
            this.documentHelper.dialog.buttons = [{
                    click: this.okButtonClick,
                    buttonModel: { content: this.localObj.getConstant('Ok'), cssClass: 'e-flat', isPrimary: true }
                },
                {
                    click: this.hideDialog,
                    buttonModel: { content: this.localObj.getConstant('Cancel'), cssClass: 'e-flat' }
                }];
            this.documentHelper.dialog.dataBind();
            this.passwordTextBox.value = '';
            this.documentHelper.dialog.show();
        };
        /**
         * @private
         * @returns {void}
         */
        this.okButtonClick = () => {
            const password = this.passwordTextBox.value;
            const empty = '';
            if (password.length === empty.length && password === empty) {
                DialogUtility.alert(this.localObj.getConstant('The password is incorrect'));
                return;
            }
            this.viewer.owner.editorModule.stopProtection(password);
        };
        /**
         * @private
         * @returns {void}
         */
        this.hideDialog = () => {
            this.passwordTextBox.value = '';
            this.documentHelper.dialog.hide();
        };
        this.documentHelper = documentHelper;
        this.owner = owner;
    }
    get viewer() {
        return this.owner.viewer;
    }
    initDialog(localValue) {
        //const instance: UnProtectDocumentDialog = this;
        const id = this.viewer.owner.containerId + '_enforce_protection';
        this.target = createElement('div', { id: id, className: 'e-de-enforce' });
        const container = createElement('div');
        const newPassWord = createElement('div', {
            className: 'e-de-unprotect-dlg-title',
            innerHTML: localValue.getConstant('Password')
        });
        this.passwordTextBox = createElement('input', {
            attrs: { type: 'password' },
            id: this.viewer.owner.containerId + '_display_text', className: 'e-input e-de-enforce-dlg-input'
        });
        // this.passwordTextBox.addEventListener('keyup', instance.onKeyUpOnDisplayBox);
        container.appendChild(newPassWord);
        container.appendChild(this.passwordTextBox);
        this.target.appendChild(container);
    }
    /**
     * @private
     * @returns {void}
     */
    destroy() {
        this.documentHelper = undefined;
        this.owner = undefined;
    }
}
